import { render, staticRenderFns } from "./LogisticsAddresses.vue?vue&type=template&id=6791ded9&scoped=true"
import script from "./LogisticsAddresses.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogisticsAddresses.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LogisticsAddresses.vue?vue&type=style&index=0&id=6791ded9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791ded9",
  null
  
)

export default component.exports